// Из какого объявления Директа пришёл посетитель: группа выбирает сценарий и заголовок лендинга.
// Объявления ставят utm_content={gbid}_{ad_id}, то есть номер группы Директа, а не A1…B6,
// поэтому номера групп кампании «Ядро» (715128304) сопоставлены с группами плана здесь.
export const DIRECT_GROUP_SOURCES = Object.freeze({
  5809486082: "A1",
  5809486083: "A2",
  5809486084: "A3",
  5809486085: "A4",
  5809486086: "A5",
  5809486087: "A6",
  5809486088: "A7",
  5809486089: "A8",
  5809486090: "A9",
  5809548798: "B1",
  5809548799: "B2",
  5809548800: "B3",
  5809548801: "B4",
  5809548802: "B5",
  5809548803: "B6",
});

// Из большинства переходов с Яндекса query не доходит (в Метрике 68 из 82 визитов 19–26.10
// без utm), а якорь ссылки доходит всегда. #unit стоит только у объявлений калькулятора и
// юнит-экономики (A1–A6, A9), поэтому по нему открываем калькулятор.
const HASH_SCENARIOS = Object.freeze({ unit: "calc" });

// sources и scenarios — ключи, которые знает лендинг: { source, scenario }, пустая строка — нет.
export function readEntry({ search = "", hash = "", sources = {}, scenarios = {} } = {}) {
  const params = new URLSearchParams(search);
  const raw = String(params.get("utm_content") || params.get("g") || "").toUpperCase();
  const named = raw.match(/[AB]\d/)?.[0];
  const byGroup = DIRECT_GROUP_SOURCES[raw.split("_")[0]];
  const source = [named, byGroup].find((key) => key && sources[key]) || "";

  const requested = params.get("s");
  const fromHash = HASH_SCENARIOS[String(hash).replace(/^#/, "")];
  const scenario = [requested, fromHash].find((key) => key && scenarios[key]) || "";

  return { source, scenario };
}
